export default function Logo({ size = 30, withWordmark = true }) {
  return (
    <span className="inline-flex items-center gap-2.5 select-none">
      <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
        <rect width="32" height="32" rx="7" fill="#0F1115" />
        <path d="M7 7l9 18L25 7h-4.6L16 16.9 11.6 7z" fill="#00E5FF" />
        <circle cx="25.5" cy="6.5" r="2.2" fill="#fff" />
      </svg>
      {withWordmark && (
        <span className="font-display font-semibold text-lg tracking-tight text-white">
          VORTEX
        </span>
      )}
    </span>
  );
}
